import { initReactI18next } from 'react-i18next/initReactI18next'
import i18n from 'i18next'

import adminEN from 'locales/en/admin.json'
import adminActionsEN from 'locales/en/adminActions.json'
import authEN from 'locales/en/auth.json'
import cartEN from 'locales/en/cart.json'
import commonEN from 'locales/en/common.json'
import contactEN from 'locales/en/contact.json'
import daysEN from 'locales/en/days.json'
import homepageEN from 'locales/en/homepage.json'
import locationsEN from 'locales/en/locations.json'
import newsletterEN from 'locales/en/newsletter.json'
import pageTitlesEN from 'locales/en/pageTitles.json'
import requestsEN from 'locales/en/requests.json'
import searchEN from 'locales/en/search.json'
import statusesEN from 'locales/en/statuses.json'
import testimonialsEN from 'locales/en/testimonials.json'
import leidPartnerEN from 'locales/en/leidPartner.json'

import adminNO from 'locales/nb/admin.json'
import adminActionsNO from 'locales/nb/adminActions.json'
import authNO from 'locales/nb/auth.json'
import cartNO from 'locales/nb/cart.json'
import commonNO from 'locales/nb/common.json'
import contactNO from 'locales/nb/contact.json'
import daysNO from 'locales/nb/days.json'
import homepageNO from 'locales/nb/homepage.json'
import locationsNO from 'locales/nb/locations.json'
import newsletterNO from 'locales/nb/newsletter.json'
import pageTitlesNO from 'locales/nb/pageTitles.json'
import requestsNO from 'locales/nb/requests.json'
import searchNO from 'locales/nb/search.json'
import statusesNO from 'locales/nb/statuses.json'
import testimonialsNO from 'locales/nb/testimonials.json'
import leidPartnerNO from 'locales/nb/leidPartner.json'

import { DEFAULT_LANG } from './constants'

const resources = {
  en: {
    common: commonEN,
    days: daysEN,
    homepage: homepageEN,
    contact: contactEN,
    search: searchEN,
    auth: authEN,
    // faq: faqEN,
    cart: cartEN,
    admin: adminEN,
    // tOU: termsOfUseEN,
    // privacyPolicy: privacyPolicyEN,
    pageTitles: pageTitlesEN,
    newsletter: newsletterEN,
    adminActions: adminActionsEN,
    statuses: statusesEN,
    testimonials: testimonialsEN,
    locations: locationsEN,
    requests: requestsEN,
    leidPartner: leidPartnerEN,
  },
  no: {
    common: commonNO,
    days: daysNO,
    homepage: homepageNO,
    contact: contactNO,
    search: searchNO,
    auth: authNO,
    // faq: faqNO,
    cart: cartNO,
    admin: adminNO,
    // tOU: termsOfUseNO,
    // privacyPolicy: privacyPolicyNO,
    pageTitles: pageTitlesNO,
    newsletter: newsletterNO,
    adminActions: adminActionsNO,
    statuses: statusesNO,
    testimonials: testimonialsNO,
    locations: locationsNO,
    requests: requestsNO,
    leidPartner: leidPartnerNO,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANG,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'a'],
  },
})

export default i18n
